import styled from 'styled-components';

const RoomView = styled.div`
  display: flex;
  min-width: 320px;
  background-color: var(--gray0);
  .base-input {
    width: 50%;
    padding: 0.5em;
    padding-right: 1em;
    &__row {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &__count {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 3em;
      button {
        width: 2em;
        height: 2em;
        line-height: 1.5em;
        text-align: center;
        border-radius: 50%;
        border: 1px solid var(--blue600);
        background-color: var(--gray0);
        color: var(--blue600);
        padding: 0;
        cursor: pointer;
        &:hover {
          background-color: var(--blue100);
        }
        &:focus {
          outline: none;
        }
        i {
          font-size: 1.5em;
          line-height: 1.25em;
        }
      }
      span {
        width: 1.5em;
        height: 2em;
        line-height: 2em;
        text-align: center;
      }
    }
    &__note {
      display: block;
      font-size: 0.75em;
      color: var(--gray600);
    }
  }
  .age-input {
    width: calc(50% - 1em);
    padding: 0.5em;
    padding-left: 1em;
    border-left: 1px solid var(--gray300);
    &__row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 0.5em;
      font-size: 0.875em;
      &:last-of-type {
        margin-bottom: 0;
      }
    }
    select {
      color: var(--blue600);
      border: 1px solid var(--blue600);
      background-color: var(--gray0);
      height: 2em;
      min-width: 3.5em;
      font-size: 16px;
    }
  }
  .input-title {
    font-size: 0.875em;
    margin: 0;
    white-space: nowrap;
    letter-spacing: 0.5px;
  }
`;

export default RoomView;
